import React, { useState } from "react";
import LoadingScreen from "../components/LoadingScreen";
import CursorGlow from "../components/CursorGlow";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import SocialProof from "../components/SocialProof";
import LogoCarousel from "../components/LogoCarousel";
import About from "../components/About";
import ForWho from "../components/ForWho";
import HarbizPlans from "../components/HarbizPlans";
import Pricing from "../components/Pricing";
import Results from "../components/Results";
import ContentPreview from "../components/ContentPreview";
import Blog from "../components/Blog";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import StickyMobileCTA from "../components/StickyMobileCTA";
import ExitIntentPopup from "../components/ExitIntentPopup";
import VideoModal from "../components/VideoModal";
import GenderPopup from "../components/GenderPopup";
import { GenderPopupProvider } from "../context/GenderPopupContext";

export default function Landing() {
  const [videoOpen, setVideoOpen] = useState(false);
  return (
    <GenderPopupProvider>
      <div className="relative bg-[#0A0A0A] text-white min-h-screen" data-testid="landing-page">
        <LoadingScreen />
        <CursorGlow />
        <Navbar />
        <main>
          <Hero onWatchStory={() => setVideoOpen(true)} />
          <SocialProof />
          <LogoCarousel />
          <About />
          <ForWho />
          <HarbizPlans />
          <Pricing />
          <Results />
          <ContentPreview />
          <Blog />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
        <StickyMobileCTA />
        <ExitIntentPopup />
        <GenderPopup />
        <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} />
      </div>
    </GenderPopupProvider>
  );
}
